import { isEmpty } from 'lodash';
import { useContext } from 'react';
import { StyleProp, ViewStyle } from 'react-native';
import { Text } from '@shared/components/Text';
import { View } from '@shared/components/View';
import { FileUpload } from '@shared/components/blocks/types';
import { MBIconV2 } from '@shared/components/image';
import { ColorThemeContext, grid } from '@shared/styles';
import { i18n } from '@shared/util/i18n';
import { isImage } from '@shared/util/media/type';
import { FileListItem } from './FileListItem';

interface FilesProps {
  files: FileUpload[];
  editable: boolean;
  onRemoved?(file: FileUpload): void;
  compactFileView: boolean;
  style?: StyleProp<ViewStyle>;
}

export function FileList({ files, onRemoved, editable, style, compactFileView }: FilesProps) {
  const colors = useContext(ColorThemeContext);
  const filesToShow = files.filter(file => {
    return !isImage(file);
  });

  if (isEmpty(filesToShow)) {
    return null;
  }

  if (!compactFileView) {
    return (
      <>
        {filesToShow.map(file => {
          return (
            <View key={file.url}>
              <View style={{ height: grid(1) }} />
              <FileListItem
                file={file}
                style={style}
                // @ts-expect-error -- strict migration
                onClear={() => onRemoved(file)}
                editable={editable}
              />
            </View>
          );
        })}
      </>
    );
  }

  return (
    <View row>
      <MBIconV2 name="file" color={colors.foregroundActive} size={30} />
      <View centerVertically>
        <Text size="body1" weight="semibold">
          {i18n('card.blocks.file.fileCount', { count: filesToShow.length })}
        </Text>
      </View>
    </View>
  );
}
